import CitizenFunctions from './citizen';
import CompanyFunctions from './company';
import AttendanceFunctions from './attendance';
import CompanyPagesFunctions from './company-pages';
import CreateRecordsFunctions from './create-records';
import EffortsFunctions from './efforts';
import OutboxFunctions from './outbox';
import SearchFunctions from './search';
import ServiceProviderFunctions from './serviceprovider';
import MedicalCollaborationFunctions from './medical-collaboration';
import CitizenCommunicationFunctions from './citizen-communication';
import CitizenInformationFunctions from './citizen-information';
import FromComponentsFunctions from './fromComponents';

const Index = [
  ...CitizenFunctions,
  ...CompanyFunctions,
  ...CompanyPagesFunctions,
  ...CreateRecordsFunctions,
  ...AttendanceFunctions,
  ...EffortsFunctions,
  ...OutboxFunctions,
  ...SearchFunctions,
  ...ServiceProviderFunctions,
  ...MedicalCollaborationFunctions,
  ...CitizenCommunicationFunctions,
  ...CitizenInformationFunctions,
  ...FromComponentsFunctions,
];

export default Index;
